import { CommodityWarehouse } from './commodity-warehouse';
import { User } from './user';

export class Warehouse {
  name!: string;
  description?: string;
  number_of_loading_bays?: number;
  floor_area?: number;
  capacity_tonnes?: number;
  storage_rate_per_tonne_per_day?: number;
  storage_free_days?: number;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  commodity_warehouses?: Array<CommodityWarehouse>;

  static getSortColumns() {
    return ['name', 'description', 'number_of_loading_bays', 'status'];
  }

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.number_of_loading_bays = data.number_of_loading_bays;
    this.floor_area = data.floor_area;
    this.capacity_tonnes = data.capacity_tonnes;
    this.storage_rate_per_tonne_per_day = data.storage_rate_per_tonne_per_day;
    this.storage_free_days = data.storage_free_days;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
        if(data.commodity_warehouses){
      this.commodity_warehouses = data.commodity_warehouses.map((el: any) => new CommodityWarehouse(el));
    }
  }
}
